import { createStore, applyMiddleware } from 'redux';
import createInfrastructure from './infrastructure/composition';
import createApplication from './application/composition';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './domain/reducer';
import * as signals from './application/signals';

export default function composition({
  config,
}) {
  const infrastructure = createInfrastructure({
    document,
  });
  const application = createApplication({
    optInRepo: infrastructure.optInRepo,
    optOutRepo: infrastructure.optOutRepo,
    saveInteraction: infrastructure.saveInteraction,
    fetchOptsRepo: infrastructure.fetchOptsRepo,
    emitEvent: infrastructure.emitEvent,
    cleanseRepo: infrastructure.cleanseRepo,
  });

  const store = createStore(
    reducer,
    {
      config,
    },
    composeWithDevTools(
      applyMiddleware(
        application.epicMiddleware,
      ),
    ),
  );

  return {
    store,
    init: () => {
      store.dispatch(signals.bootstrap());
    },
  };
}



// WEBPACK FOOTER //
// ./src/composition.js